<template>

    <div class="row">
       <div class="col-md-12">


        <div class="row justify-content-center align-items-center min-vh" v-if="details === null">
            <div class="col-md-12 text-center">
                <div class="d-flex justify-content-center" >
                  <div class="align-self-center flex-grow-1">
                    <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  </div>
                </div>
            </div>
        </div>

        <div class="row min-vh" v-else>
          <div class="col-md-12">
             <section class="content-inner" >
                <div class="card">
                  <div class="card-header pt-0 pb-2">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb  px-0 pb-0" >   
                          <li class="breadcrumb-item"  v-for="(breadcrumb, index) in breadcrumbs">
                            <span v-if="index == 0" >
                              <a href="/transfers" >Transfers </a>
                            </span>
                            <span v-if="index > 0">
                              <a :href="'/files?folder_id='+breadcrumb.id" > {{(breadcrumb.name == 'My Files' ? 'Files' : breadcrumb.name)}}</a>
                            </span>
                            <span class="slash" v-if="index != breadcrumbs.length - 1">/</span>
                          </li>
                          
                        </ol>
                    </nav>
                    <a href="javascript:void(0);" class="file_name pb-2" style="word-break: break-all;">{{ details.name }}</a>
                  </div>
                  <div class="card-body  p-0">
                    <div class="d-none d-md-block">
                      <div class="d-flex flex-row">
                        <div>
                          <button @click="goBack('/files?folder_id=' + details.folder_id)"  class="toolbar-action border-right">Back to Folder</button>
                        </div>
                        <div>
                           <button @click="download(details.link)" class="toolbar-action border-right">Download ( .{{ details.name.split('.').pop() }}, {{ details.size | humanFileSize}} ) </button>
                        </div>
                      </div>
                    </div>
                    <div class="d-md-none">
                      <div class="d-flex flex-column">
                        <div class=" border-bottom text-center">
                          <button @click="goBack('/files?folder_id=' + details.folder_id)"  class="toolbar-action w-100">Back to Folder</button>
                        </div>
                        <div class=" border-bottom text-center">
                           <button @click="download(details.link)" class="toolbar-action  w-100">Download ( .{{ details.name.split('.').pop() }}, {{ details.size | humanFileSize}} ) </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body p-2 p-md-4" v-if="details.mime_type.includes('text/')">
                    <div class="row">
                        <div class="col ">
                          <div class="row">
                               <div class="col-md-12 w-100  d-flex justify-content-center" style="height:400px;">
                                  <pre class="w-100 p-1">{{ txt_content }}</pre>
                               </div>
                          </div>
                        </div>
                    </div>

                  </div>
                  <div class="card-body p-0 p-lg-5" v-else>
                      <div class="row">
                        <div class="col ">
                            <div class="row" v-if="details.mime_type.includes('video/')">
                              <!-- <div class="col-md-12 w-100 bg-dark d-flex justify-content-center" v-if="details.transcode_status == 'pending' || details.transcode_status == 'running'" style="height:450px;">
                                <div class="align-middle align-self-center text-white text-center">
                                  <p class="mb-3" style="font-size: 25px;">Processing</p>
                                  <p class="mb-3" style="font-size: 20px;">Watch now with Live Player?</p>
                                  <a :href="details.livestreaming_url" target="_blank" class="btn  mb-2" style="padding-left: 55px;padding-right: 55px; font-size: 20px; background: white!important; color: #000; ">Start Live Player</a>
                                </div>
                              </div> -->
                              <div class="col-md-12" v-if="details.transcode_status == 'good_as_is' || details.transcode_status == 'finished' || details.transcode_status == 'running' || details.transcode_status == 'pending'">
                                <video-player :options="video_options" :type="details.mime_type" :id="details.id" :hash="details.opensubtitles_hash"/>
                              </div>
                              <div class="col-md-12 w-100 bg-dark d-flex justify-content-center" v-else style="height:450px;">
                                 <h2 class="align-middle align-self-center text-white text-center">Error playing this file, sorry.</h2>
                              </div>
                            </div>
                            <div class="row" v-else-if="details.mime_type.includes('audio/')">
                              <div class="col-md-12" >
                                <video-player :options="video_options" :type="details.mime_type" :id="details.id" :hash="details.opensubtitles_hash"/>
                              </div>
                            </div>
                             <div class="row" v-else-if="details.mime_type.includes('image/')">
                                <div class="col-md-12 fullscreen-wrapper">
                                    <img :src="details.link" class="img-fluid w-100" @click="toggle"/>
                                </div>
                             </div>
                             <div class="row" v-else-if="details.mime_type.includes('/pdf')">
                              <div class="col-md-12 w-100 d-flex justify-content-center" style="height: 600px;">
                                <iframe :src="'https://docs.google.com/gview?url='+ details.link + '&embedded=true'" width="100%" height="100%"></iframe>
                              </div>
                             </div>
                             <div class="row" v-else>
                                <div class="col-md-12 w-100 bg-dark d-flex justify-content-center" style="height:450px;">
                                   <h2 class="align-middle align-self-center text-white text-center">This file type cannot be previewed at the moment.</h2>
                                </div>
                             </div>
                        </div>
                      </div>
                  </div>
                </div>
              </section>
          </div>
        </div>

      </div>
    </div>
</template>
<script>
  import VideoPlayer from "./VideoPlayerComponent.vue";
  import { api as fullscreen } from 'vue-fullscreen';
  export default {
    components: {
      VideoPlayer
    },
    data() {
      return {
        tree : null,
        file_id: this.getParameterFromUrl('id'),
        breadcrumbs: {},
        details: null,
        video_options: {},
        move_destination: {},
        txt_content: null,
        rename_item: false,
        fullscreen: false,
        teleport: false,
      };
    },
    filters: {
        humanFileSize: (bytes) => {
            var thresh = 1024;
            if(Math.abs(bytes) < thresh) {
                return bytes + ' B';
            }
            var units = ['KB','MB','GB','TB','PB','EB','ZB','YB'];
            var u = -1;
            do {
                bytes /= thresh;
                ++u;
            } while(Math.abs(bytes) >= thresh && u < units.length - 1);
            return bytes.toFixed(1)+' '+units[u];
        },

    },
    mounted() {
      this.fileDetails();
    },
    methods: {
      async toggle () {
        await fullscreen.toggle(this.$el.querySelector('.fullscreen-wrapper'), {
          teleport: this.teleport,
          callback: (isFullscreen) => {
            //this.fullscreen = isFullscreen
          },
        })
        this.fullscreen = fullscreen.isFullscreen
      },
      getParameterFromUrl: function(param){
          var result = null,
            tmp = [];
          var items = location.search.substr(1).split("&");
          for (var index = 0; index < items.length; index++) {
            tmp = items[index].split("=");
            if (tmp[0] === param) result = decodeURIComponent(tmp[1]);
          }
          return result
      },
      goBack(link) {
          window.location.href = link; 
      },
      download(link){
        window.open(link);   
      },
      changeFolder (id,name) {
          this.move_destination = {'id' : id, 'name' : name};
      },
      moveItemModal () {
          $('#selectFolderModal').modal('toggle');
      },
      pasteMoveItem(e){
          e.target.disabled = true;
          e.target.innerHTML = '<i class="fas fa-spinner fa-pulse"></i> Moving'
          axios.post('/api/item/paste',{folder_id : this.move_destination.id, item_type: this.details.type, item_id : this.details.id}).then( response=> {
              e.target.disabled = false;
              e.target.innerHTML = 'Move File'
              flash(response.data.message, 'success');
              $('#selectFolderModal').modal('toggle');
              this.fileBreadCrumbs(this.move_destination.id);
          }).catch(error=>{
              e.target.disabled = false;
              e.target.innerHTML = 'Move File'
              $('#selectFolderModal').modal('toggle');
              flash(JSON.parse(error.request.response).message, 'error');
          });
      },
      moveItems(){
        $('#selectFolderModal').modal('toggle');
      },
      renameItem(){
        this.rename_item = true;
      },
      saveRenameItem(){
        axios.post('/api/item/rename',{id : this.file_id, name : this.details.name}).then( response=> {
          this.rename_item = false;
          this.breadcrumbs[this.breadcrumbs.length - 1].name = this.details.name;
        }).catch(error=>{
            flash(JSON.parse(error.request.response).message, 'error');
        });
      },
      deleteItemModal(){
          $('#deleteModal').modal('toggle');
      },
      deleteItem(){

          if(this.move_destination.id){
            var redirect = '/my-files?folder_id='+this.move_destination.id;
          } else {
            var redirect = '/my-files?folder_id='+this.details.folder_id;
          }

          $('#delete_item_btn').attr("disabled", true).html('<i class="fas fa-spinner fa-pulse"></i> Deleting').removeClass('btn-success').addClass('btn-secondary');
          axios.delete('/api/item/delete/'+this.file_id).then(response=>{
            $('#delete_item_btn').attr("disabled", false).html('Yes').removeClass('btn-secondary').addClass('btn-success');
            $('#deleteModal').modal('toggle');
            flash(response.data.message, 'success');
            //redirect to parent folder
            window.location = redirect;

          }).catch(error=>{
              $('#delete_item_btn').attr("disabled", false).html('Yes').removeClass('btn-secondary').addClass('btn-success');
              flash(JSON.parse(error.request.response).message, 'error');
          });
      },
      fileDetails(){
        axios.post('/api/item/details',{file_id : this.file_id}).then(response=>{
            this.details = response.data.details;
            this.breadcrumbs = response.data.breadcrumbs;

            if(this.details.mime_type.includes('text/')){

                var xhr = new XMLHttpRequest();
                xhr.open("GET", this.details.link, false);
                xhr.send();

                this.txt_content = xhr.responseText;
            }

            if(this.details.mime_type.includes('video/')){

              var live_transcode_server_url = process.env.MIX_LIVETRANSCODE_URL;
              var live_video_url = live_transcode_server_url + this.details.directlink + '/index.m3u8';
              var player_link = ((this.details.transcode_status == 'good_as_is' || this.details.transcode_status == 'finished') ? this.details.stream_link : live_video_url);

              this.video_options = {
                autoplay: false,
                controls: true,
                aspectRatio: "640:360",
                sources: [
                  {
                    src:
                      player_link,
                       type: (this.details.transcode_status == 'good_as_is' || this.details.transcode_status == 'finished') ? 'video/mp4' : 'application/x-mpegURL'
                  }
                ],
                html5: {
                  hls: {
                    limitRenditionByPlayerDimensions: true,
                    useDevicePixelRatio: true,
                    useNetworkInformationApi: true
                  }
                },
                fluid: true,
                techOrder: [ 'html5', 'chromecast' ],
                plugins: {
                  airPlay: {},
                  chromecast: {}
                }
              };

            } else if(this.details.mime_type.includes('audio/')){

                var player_link = (this.details.stream_link ? this.details.stream_link : this.details.link);

                this.video_options = {
                  controlBar: {
                    fullscreenToggle: false,
                    pictureInPictureToggle: false
                  },
                  sources: [
                    {
                      src:
                        player_link,
                        type: 'audio/mp3'
                    }
                  ],
                };
            }
            

        }).catch(error=>{
          console.log(error);
        });
      },
      folderTree(){
        axios.get('/api/folder/tree').then(response=>{
            this.tree = response.data.folder_tree;
        }).catch(error=>{
          console.log(error);
        });
      },
      fileBreadCrumbs(folder_id){
        axios.post('/api/item/breadcrumbs',{folder_id : folder_id}).then(response=>{
            this.breadcrumbs = response.data.breadcrumbs;
        }).catch(error=>{
          console.log(error);
        });
      }
    }
  }
</script>
